import styled from 'styled-components';

const Backdrop = styled.div`
  position: fixed; inset: 0; background: rgba(0,0,0,0.35); display: grid; place-items: center; z-index: 500;
`;
const Modal = styled.div`
  width: 600px; background: #fff; border-radius: 16px; padding: 20px; box-shadow: 0 14px 32px rgba(0,0,0,0.18);
`;
const LightInput = styled.input`
  padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221; width:100%; box-sizing:border-box;
`;
const Btn = styled.button`
  background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;
`;

type GroupDraft = { id?: string; name: string; startTime: string; endTime: string };

type Props = {
  initial: GroupDraft;
  onClose: () => void;
  onSave: (draft: GroupDraft) => Promise<void>;
};

const dateToInputValue = (iso?: string) => iso ? new Date(iso).toISOString().slice(0,16) : '';

export const GroupEditModal = ({ initial, onClose, onSave }: Props) => {
  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e=> e.stopPropagation()}>
        <h3 style={{marginTop:0}}>{initial.id? 'Редактировать поток' : 'Создать поток'}</h3>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          <div>
            <div style={{fontSize:12, color:'#465676', marginBottom:6}}>Название</div>
            <LightInput defaultValue={initial.name} onChange={e=> (initial.name = e.target.value)} />
          </div>
          <div></div>
          <div>
            <div style={{fontSize:12, color:'#465676', marginBottom:6}}>Начало</div>
            <input type="datetime-local" defaultValue={dateToInputValue(initial.startTime)} onChange={e=> (initial.startTime = new Date(e.target.value).toISOString())} style={{ padding:10, borderRadius:10, border:'1px solid #dbe3f6', color:'#0b1221' }} />
          </div>
          <div>
            <div style={{fontSize:12, color:'#465676', marginBottom:6}}>Окончание</div>
            <input type="datetime-local" defaultValue={dateToInputValue(initial.endTime)} onChange={e=> (initial.endTime = new Date(e.target.value).toISOString())} style={{ padding:10, borderRadius:10, border:'1px solid #dbe3f6', color:'#0b1221' }} />
          </div>
        </div>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:8, marginTop:12 }}>
          <Btn onClick={onClose}>Отмена</Btn>
          <Btn onClick={async()=> { await onSave(initial); onClose(); }}>Сохранить</Btn>
        </div>
      </Modal>
    </Backdrop>
  );
};


